import { Loader2 } from "lucide-react";

export default function LoadingSpinner({ text = "Wird berechnet…" }: { text?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-12" role="status" aria-live="polite">
      <Loader2 className="w-10 h-10 text-neko-orange animate-spin mb-3" />
      <p className="text-neko-gray text-sm">{text}</p>
    </div>
  );
}
